import React, { Component } from "react";
import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Select,
} from "antd";
import {
    dineroDisabledMask,
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    round2Decimals,
    ButtonItem,
    round6Decimals,
    DatePickerItem,
    SwitchItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreoDevolucion from "../MandarCorreoDevolucion/MandarCorreoDevolucion";
import { DollarOutlined, DownloadOutlined, SendOutlined } from "@ant-design/icons";
import VentasForm from "../../../../Components/VentasForm";
import PagosDevolucion from "../PagosDevolucion/PagosDevolucion";
import devolucionFPdf from "../../../../Pdf/devolucionFPdf";
import devolucionRPdf from "../../../../Pdf/devolucionRPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

moment.locale("es");

class VerDevolucion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        objetoProveedores: null,
        todasProveedores: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoInsumos: (
            <Option disabled value={0} key={0}>
                Seleccione un proveedor primero
            </Option>
        ),
        todasInsumos: [],
        objetoMonedas: null,
        todasMonedas: null,
        impuestos: [],
        modalConfirmacion: false,
        valuesForm: null,
        id: this.props.location.state.id,
        datosVenta: null,
        tipoDeCambioVenta: 0,
        totalVenta: 0,
        totalPagarVenta: 0,
        subtotalVenta: 0,
        arrayImpuestosVenta: [],
        arrayRetencionesVenta: [],
        modalCorreo: false,
        modalCorreoId: null,
        total: 0,
        totalPagar: 0,
        totalPagado: 0,
        subtotal: 0,
        ajusteSubtotal: 0,
        arrayImpuestos: [],
        arrayRetenciones: [],
        modalPagos: false,
        estado: 0,
        objetoBancos: null,
        todasBancos: null,
    };
    async componentDidMount() {
        this.setState({ loading: true });
        await this.consultarTodo()
        if (this.props?.location?.state?.fileName) {
            this.leerXmlData(this.props.location.state)
        }
        this.setState({ loading: false });
    }

    promisedSetState = (newState) => new Promise(resolve => this.setState(newState, resolve));

    async consultarTodo() {

        this.setState({ loading: true });

        await axios
            .post(
                "devoluciones/selectDatosParaDevolucion",
                { empresaId: this.props.empresaId, notaId: this.state.id },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasClientes: res.data.clientes,
                        todasProyectos: res.data.proyectos,
                        todasPrecios: res.data.precios,
                        todasFormasDePago: res.data.formasDePago,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        todasBancos: res.data.bancosYCajas,
                        todasInsumos: res.data.insumosVenta,
                        todasUsuarios: res.data.usuariosEmpresa,
                        todasMonedas: res.data.monedas,
                        venderSinInventario: res.data.venderSinInventario,
                        objetoClientes: res.data.clientes.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.stringBuscar}
                                </Option>
                            );
                        }),
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoPrecios: res.data.precios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoFormasDePago: res.data.formasDePago.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_FormaPago + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                         objetoInsumos: res.data.insumosVenta.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre || value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre +
                                        " " +
                                        value.apellidoPaterno +
                                        " " +
                                        value.apellidoMaterno}
                                </Option>
                            );
                        }),
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        objetoBancos: res.data.bancosYCajas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                } else {
                    message.warning('No se encontro informacion de la venta')
                }
            });

        await axios
            .post(
                "devoluciones/datosDevolucion",
                { empresaId: this.props.empresaId, devolucionId: this.state.id },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                    message.error("Error no se encontro informacion de la devolución");
                } else {
                    this.formRef.current.setFieldsValue({
                        ...res.data,
                        fechaDevolucion: moment(res.data.fechaDevolucion),
                        factura: res.data.factura ? 1 : 2,
                        insumos: res.data.insumos.map(insumo => {
                            const precioUnitarioConImpuestos = insumo.precioUnitario + (insumo.impuestos / insumo.cantidad)
                            return { ...insumo, precioUnitarioConImpuestos }
                        })
                    });

                    this.setState({ 
                        estado: res.data.estado, 
                        total: res.data.total, 
                        totalPagar: res.data.totalPagar, 
                        totalPagado: res.data.totalPagado, 
                        subtotal: res.data.subtotal, 
                        arrayImpuestos: res.data.arrayImpuestos, 
                        arrayRetenciones: res.data.arrayRetenciones, 
                        ajusteSubtotal: res.data.ajusteSubtotal,
                        datosVenta: res.data.datosVenta || null
                    })
                }
            });

        this.setState({ loading: false });

    }

    atras() {
        this.props.history.goBack();
    }
    async onChangeInsumoProyecto(value, key, tipo) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let precioId = await this.formRef.current.getFieldValue("precioId");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        let proyectoId = arrayValue[key].proyectoId;
        const insumoId = arrayValue[key].insumoId;
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === insumoId
        );
        if (!insumo) return;
        if (insumo.inventariable || insumo.insumoCompuesto) {
            await axios
                .post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                        proyectoId: proyectoId,
                        insumoId: insumoId,
                        noPrincipal: insumo.noPrincipal,
                        insumoCompuesto: insumo.insumoCompuesto,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    arrayValue[key].cantidadProyecto = res.data.cantidad;
                });
        } else {
            arrayValue[key].cantidadProyecto = "No inventariable";
        }
        const precio = insumo.precios.find(
            (valuePrecios) => valuePrecios.precioId?.toString() === precioId
        );
        if (precio) {
            arrayValue[key].precioUnitario = precio.precio;
        } else {
            message.info("Este insumo no tiene ese precio");
            arrayValue[key].precioUnitario = 0;
        }

        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );

        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            const subtotal = round6Decimals(cantidad * precioUnitario);
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })

                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }
        }

        this.formRef.current.setFieldsValue({
            insumos: arrayValue
        });
        this.setState({ flete: (!!insumo.flete || this.state.flete) })
    }
    async onChangePrecioCantidadDescuento(value, key) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;
        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );
        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            const subtotal = round6Decimals(cantidad * precioUnitario);
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })
                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    onChangeCliente(valueId) {
        const contado = this.formRef.current.getFieldValue("contado");
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === valueId
        );
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        let objetoCambiar = {}
        if (cliente.usoDeCFDIID) {
            objetoCambiar.usoDeCfdiId = cliente.usoDeCFDIID
        }
        if (cliente.precioContadoId || cliente.precioCreditoId) {
            objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
        }
        if (cliente.proyectoId) {
            objetoCambiar.proyectoId = cliente.proyectoId
        }
        if (cliente.vendedorId && this.state.ponerVendedor && this.state.todasUsuarios?.find(u => u._id?.toString() === cliente.vendedorId?.toString())) {
            objetoCambiar.vendedorId = cliente.vendedorId
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            }
        })
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            ...objetoCambiar
        });
    }
    onChangeContado(value) {
        if (value !== 1) {
            this.formRef.current.setFieldsValue({
                formaDePagoId: '6125149afe07662acc100d6d'
            })
        } else {
            this.formRef.current.setFieldsValue({
                formaDePagoId: '6125149afe07662acc100d58'
            })
        }
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        if (!clienteId) return;
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === clienteId
        );
        this.formRef.current.setFieldsValue({
            precioId: value === 1 ? cliente.precioContadoId : cliente.precioCreditoId,
        });
    }
    abrirElegirTipoDeCliente(id, nombre) {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    }
    cerrarElegirTipoDeCliente(elegido) {
        if (!elegido) {
            this.formRef.current.setFieldsValue({ clienteId: undefined });
        }
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    }
    cerrarMandarCorreoDevolucion() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
    }
    abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
        if (proyectoId) {
            this.setState({
                modalElegirMarbetes: true,
                modalElegirMarbetesIndex: value,
                modalElegirMarbetesMarbetes: marbetes || [],
                modalElegirMarbetesInsumoId: insumoId,
                modalElegirMarbetesProyectoId: proyectoId
            })
        } else {
            message.warning('Elegir un proyecto para elegir marbetes')
        }
    }
    cerrarElegirMarbetes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalElegirMarbetesIndex].marbetes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirMarbetes: false,
            modalElegirMarbetesIndex: null,
            modalElegirMarbetesMarbetes: null,
            modalElegirMarbetesInsumoId: null,
            modalElegirMarbetesProyectoId: null
        })
    }

    descargarDevolucion(value) {
        axios
            .post(
                "devoluciones/datosPdf",
                { devolucionId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.factura) {
                    var xmltext = res.data.respuestaFactura.data.cfdi;
                    const dataSat = res.data.respuestaFactura.dataSat
                    const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'D') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )'

                    var filename = nombreArchivo + ".xml";
                    var pom = document.createElement("a");
                    var bb = new Blob([xmltext], { type: "text/plain" });

                    pom.setAttribute("href", window.URL.createObjectURL(bb));
                    pom.setAttribute("download", filename);

                    pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(
                        ":"
                    );
                    pom.draggable = true;
                    pom.classList.add("dragout");

                    pom.click();

                    const pdf = devolucionFPdf(res.data);

                    pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                } else {
                    const dataSat = res.data.respuestaFactura.dataSat
                    const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'D') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )'

                    const pdf = devolucionRPdf(res.data);

                    pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                }
            });
    }

    enviarDevolucion(value) {
        this.setState({ modalCorreo: true, modalCorreoId: value });
    }

    cerrarPagosDevolucion() {
        this.consultarTodo()
        this.setState({
            modalPagos: false,
        });
    }

    getInsumosColumns() {
        return [
            { title: "Clave",  width: "5%" },
            { title: "Insumo", width: "15%" },
             { title: "Unidad", width: "6%" },
            { title: "Proyecto", width: "12%" },
            { title: "PU", width: "10%" },
            { title: "Precio Neto", width: "10%" },
            { title: "Cant.", width: "8%" },
            { title: "Desc.", width: "8%" },
            { title: "Subtotal / Impuesto / Total", width: "10%" }
        ];
    }

    renderInsumoRow({ key, name, fieldKey, restField, arrayKey }) {
        return (
            <React.Fragment key={key}>
                <tr>
                    <td className="td-border">
                        <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                                const insumoSeleccionado = this.state.todasInsumos?.find(
                                    (insumo) => insumo._id.toString() === insumoId?.toString()
                                );
                                return (
                                    <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                                        {insumoSeleccionado?.clave || '-'}
                                    </div>
                                );
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border">
                         <FormItem
                            {...restField}
                            name={[name, "insumoId"]}
                            required
                            noStyle
                        >
                            <SelectItem
                               noDisabledBackground
                                sinBorde
                                autoFocus
                                disabled
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Insumo"
                                style={{ boxShadow: 'none', whiteSpace: 'normal', wordBreak: 'break-word', height: 'auto', minHeight: '32px' }}
                                onChange={(value) =>
                                    this.onChangeInsumoProyecto(
                                        value,
                                        arrayKey,
                                        'insumo'
                                    )
                                }
                            >
                                {this.state.objetoInsumos}
                            </SelectItem>
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem noStyle shouldUpdate disabled>
                            {({ getFieldValue }) => {
                            const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                            const insumoSeleccionado = this.state.todasInsumos?.find(
                                (insumo) => insumo._id.toString() === insumoId?.toString()
                            );
                            return (
                                <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                                {insumoSeleccionado?.unidad || '-'}
                                </div>
                            );
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border">
                         <FormItem
                            shouldUpdate={(prev, curr) =>
                                prev.proyectoId !== curr.proyectoId
                            }
                            noStyle
                        >
                            {({ getFieldValue }) => {
                                const proyectoId =
                                    getFieldValue("proyectoId");
                                return (
                                    <FormItem
                                        {...restField}
                                        name={[name, "proyectoId"]}
                                        required
                                        noStyle
                                        initialValue={proyectoId}
                                    >
                                        <SelectItem
                                            noDisabledBackground 
                                            sinBorde
                                            disabled
                                            width="100%"
                                            placeholder="Proyecto"
                                            onChange={(value) =>
                                                this.onChangeInsumoProyecto(
                                                    value,
                                                    arrayKey,
                                                    'proyecto'
                                                )
                                            }
                                        >
                                            {this.state.objetoProyectos}
                                        </SelectItem>
                                    </FormItem>
                                );
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "precioUnitario"]} noStyle>
                            <InputNumberItem sinBorde disabled dineroDisabled />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "precioUnitarioConImpuestos"]} noStyle>
                            <InputNumberItem sinBorde disabled dineroDisabled placeholder="Precio Neto" noDisabledBackground />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "cantidad"]} noStyle>
                            <InputNumberItem sinBorde disabled  noDisabledBackground/>
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "descuento"]} noStyle>
                            <InputNumberItem sinBorde disabled  noDisabledBackground porcentajeDisabled />
                        </FormItem>
                    </td>
                   {/* Columna: Subtotal / Impuesto / Total */}
                    <td className="td-border">
                        <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                            const subtotal = getFieldValue(['insumos', arrayKey, 'subtotal']) || 0;
                            const impuestos = getFieldValue(['insumos', arrayKey, 'impuestos']) || 0;
                            const total = getFieldValue(['insumos', arrayKey, 'total']) || 0;
            
                            return (
                                  <div className="celda-totales" style={{ fontSize: '13px' }}>
                                        <div className="celda-totales" style={{ fontSize: '12px' }}>
                                            <div>{dineroDisabledMask(subtotal)}</div>
                                            <div>{dineroDisabledMask(impuestos)}</div>
                                            <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                                        </div>
                                </div>
           
                            );
                            }}
                        </FormItem>
            
                        {/* Campos hidden para mantener los valores en el form */}
                        <FormItem {...restField} name={[name, "subtotal"]} required numberCero hidden>
                            <InputNumberItem />
                        </FormItem>
                        <FormItem {...restField} name={[name, "impuestos"]} required numberCero hidden>
                            <InputNumberItem />
                        </FormItem>
                        <FormItem {...restField} name={[name, "total"]} required numberCero hidden>
                            <InputNumberItem />
                        </FormItem>
                    </td>
                </tr>
                
                {/* Fila de Leyenda */}
                       <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.leyenda !== curr.insumos[arrayKey]?.leyenda}>
                         {({ getFieldValue }) => {
                           let arrayValue = getFieldValue("insumos");
                           if (arrayValue && arrayValue[arrayKey]?.leyenda) {
                             return (
                               <tr className="fila-leyenda">
                                 <td colSpan="9" className="td-border">
                                   <div className="contenedor-leyenda">
                                     <div className="texto-leyenda">
                                       <b>Leyenda:</b> {arrayValue[arrayKey].leyenda}
                                     </div>
                                   </div>
                                 </td>
                               </tr>
                             );
                           }
                         }}
                       </FormItem>
               
               
                       {/* Fila de Observaciones */}
                       <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && (prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones || prev.insumos[arrayKey]?.observacionesXml !== curr.insumos[arrayKey]?.observacionesXml)}>
                         {({ getFieldValue }) => {
                            const arrayValue = getFieldValue("insumos") || [];
                           if (arrayValue && arrayValue[arrayKey]?.observaciones) {
                             return (
                               <tr className="fila-observaciones">
                                 <td colSpan="9" className="td-border">
                                   <div className={`contenedor-observaciones ${arrayValue[arrayKey].observacionesXml ? 'con-xml' : 'sin-xml'}`}>
                                     <div className="texto-observaciones">
                                       {String(arrayValue[arrayKey].observaciones)
                                         .split(/\r?\n/)
                                         .map((line, i) => <span key={i}>{line}<br /></span>)}
                                     </div>
                                   </div>
                                 </td>
                               </tr>
                             );
                           }
                            return null;
                         }}
                       </FormItem>
            </React.Fragment>
        );
    }

    getObservacionesConfig() {
        return {
            observaciones: {
                label: "Observaciones",
                value: this.formRef.current?.getFieldValue("observaciones") || "",
                onSave: (newValue) => {
                    this.formRef.current?.setFieldsValue({ observaciones: newValue });
                    this.forceUpdate();
                       // Guardar en backend en segundo plano
                    axios
                        .post("devoluciones/editarObservaciones", {
                            notaDeCreditoId: this.state.id,
                            empresaId: this.props.empresaId,
                            observaciones: newValue,
                        })
                        .then((res) => {
                            if (res.data.success !== 2) {
                                message.warning("Error al guardar observaciones");
                            } else {
                                message.success("Observaciones actualizadas");
                            }
                        })
                    .catch(() => {
                        message.error("Error al guardar observaciones");
                    });
                },
            },
            checkboxes: [
                {
                    label: "Imprimir",
                    name: "imprimirObservaciones",
                    onChange: (e) => {
                        axios
                        .post("devoluciones/editarImprimirObservaciones", {
                            notaDeCreditoId: this.state.id,
                            empresaId: this.props.empresaId,
                            imprimirObservaciones: e.target.checked,
                        })
                        .then((res) => {
                            if (res.data.success !== 2) {
                            message.info("La nota de crédito no se edito");
                            }
                        });
                    }
                }
            ],
            totales: null,
        };
    }

    render() {
        const isMobile = window.innerWidth <= 1000;
        return (
            <>
                <PageHeader onBack={this.atras.bind(this)} title="Ver Devolución" style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }} />
                <div className="card-background">
                    <Spin spinning={this.state.loading}>
                        <Form ref={this.formRef} name="verDevolucion" layout>
                            <FormItem noStyle shouldUpdate>
                                {({ getFieldValue }) => (
                                    <VentasForm totalPagar={this.state.totalPagar || 0} showDoctor={false} showRegimenFiscal={false} showMoneda={true}  monedaEnFila2={true}
                                        datosGeneralesContent={(
                                            <>
                                                {/* Fila 1: Cliente, Tipo, Fecha */}
                                                <Row gutter={[16, 8]} align="middle">
                                                    <Col xs={24} sm={24} md={10} lg={10} ref={this.refCliente}>
                                                        <FormItem
                                                            label="Cliente"
                                                            name="clienteId"
                                                            required
                                                            margin
                                                            labelCol={{ span: 4 }}
                                                            wrapperCol={{ span: 20 }}
                                                        >
                                                            <SelectItem disabled noDisabledBackground>{this.state.objetoClientes}</SelectItem>
                                                        </FormItem>
                                                    </Col>

                                                    {/* Tipo*/}
                                                    <Col xs={12} sm={8} md={5} lg={5} ref={this.refFactura}>
                                                        <FormItem
                                                            name="factura"
                                                            label="Tipo"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={2}
                                                            margin
                                                        >
                                                            <SelectItem disabled noDisabledBackground>
                                                                <Option value={2}>Remisión</Option>
                                                                <Option value={1}>Factura</Option>
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>

                                                    <Col xs={12} sm={8} md={5} lg={5}>
                                                        <FormItem
                                                            label="Fecha:"
                                                            name="fechaDevolucion"
                                                            required
                                                            margin
                                                            initialValue={moment()}
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 17 }}
                                                        >
                                                            <DatePickerItem disabled allowClear={false} />
                                                        </FormItem>
                                                    </Col>
                                                </Row>

                                                {/* Fila 2: Vendedor, Precio, Proyecto */}
                                                <Row gutter={[16, 8]}>
                                                    <Col xs={24} sm={24} md={10} lg={10}>
                                                        <FormItem
                                                            label="Vendedor"
                                                            name="vendedorId"
                                                            required
                                                            labelCol={{ span: 4 }}
                                                            wrapperCol={{ span: 20 }}
                                                        >
                                                            <SelectItem disabled noDisabledBackground placeholder="Vendedor">{this.state.objetoUsuarios}</SelectItem>
                                                        </FormItem>
                                                    </Col>

                                                    {/* Precio */}
                                                    <Col xs={12} sm={8} md={5} lg={5}>
                                                        <FormItem
                                                            name="precioId"
                                                            label="Precio"
                                                            required
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                        >
                                                            <SelectItem placeholder="Precio" disabled noDisabledBackground>
                                                                {this.state.objetoPrecios}
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>

                                                    {/* Proyecto */}
                                                    <Col xs={12} sm={8} md={5} lg={5}>
                                                        <FormItem
                                                            name="proyectoId"
                                                            label="Proyecto"
                                                            required
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                        >
                                                            <SelectItem placeholder="Proyecto" disabled noDisabledBackground>
                                                                {this.state.objetoProyectos}
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                        datosClienteContent={(
                                            <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                    const devolverDinero = getFieldValue('devolverDinero')
                                                    return (
                                                        <>
                                                            <FormItem
                                                                name="pagarVenta"
                                                                label="Pagar Venta"
                                                                tooltip={{ title: "Pagar la venta existente con esta devolucion" }}
                                                                margin
                                                                valuePropName="checked"
                                                                labelCol={{ span: 14 }}
                                                                wrapperCol={{ span: 10 }}
                                                            >
                                                                <SwitchItem disabled />
                                                            </FormItem>
                                                            <FormItem
                                                                name="devolverDinero"
                                                                label="Compensación"
                                                                tooltip={{ title: "Regresar el dinero al cliente" }}
                                                                margin
                                                                valuePropName="checked"
                                                                labelCol={{ span: 14 }}
                                                                wrapperCol={{ span: 10 }}
                                                            >
                                                                <SwitchItem disabled />
                                                            </FormItem>
                                                            {devolverDinero && (
                                                                <FormItem
                                                                    required
                                                                    margin
                                                                    name="bancoId"
                                                                    label="Banco"
                                                                    labelCol={{ span: 14 }}
                                                                    wrapperCol={{ span: 10 }}
                                                                >
                                                                    <SelectItem disabled noDisabledBackground placeholder="Banco">
                                                                        {this.state.objetoBancos}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            )}
                                                        </>
                                                    )
                                                }}
                                            </FormItem>
                                        )}

                                        monedaContent={(
                                             <>
                                                <FormItem
                                                    required
                                                    margin
                                                    name="monedaId"
                                                    label="Moneda"
                                                    initialValue='60c7e4396465ad440c41c15a'
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 14 }}
                                                >
                                                    <SelectItem disabled noDisabledBackground onChange={(value) => {
                                                        if (value === '60c7e4396465ad440c41c15a') {
                                                            this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                                        }
                                                    }} placeholder="Moneda">
                                                        {this.state.objetoMonedas}
                                                    </SelectItem>
                                                </FormItem>
                                                <FormItem
                                                    noStyle
                                                    shouldUpdate={(prevValues, currentValues) =>
                                                        prevValues.monedaId !== currentValues.monedaId
                                                    }
                                                >
                                                    {({ getFieldValue }) => {
                                                        const monedaId = getFieldValue("monedaId");
                                                        if (monedaId === "60c7e4396465ad440c41c15a") {
                                                            return null;
                                                        }
                                                        return (
                                                            <FormItem
                                                                required
                                                                number
                                                                margin
                                                                label="T. Cambio"
                                                                name="tipoDeCambio"
                                                                type="number"
                                                                initialValue={1}
                                                                labelCol={{ span: 8 }}
                                                                wrapperCol={{ span: 16 }}
                                                            >
                                                                <InputNumberItem disabled dinero placeholder="T. Cambio" />
                                                            </FormItem>
                                                        );
                                                    }}
                                                </FormItem>
                                                <FormItem shouldUpdate noStyle>
                                                    {({ getFieldValue }) => {
                                                        const pagarVenta = getFieldValue('pagarVenta')
                                                        const devolverDinero = getFieldValue('devolverDinero')
                                                        if (pagarVenta || devolverDinero) {
                                                            return (
                                                                <>
                                                                    <p style={{ textAlign: 'center' }}>Moneda de la venta: {this.state.datosVenta?.moneda?.abreviacion}</p>
                                                                    <FormItem
                                                                        required
                                                                        number
                                                                        margin
                                                                        label={`T. C. ${this.state.datosVenta?.moneda?.abreviacion ? this.state.datosVenta?.moneda?.abreviacion : ''}`}
                                                                        name="tipoDeCambioVenta"
                                                                        type="number"
                                                                        initialValue={1}
                                                                    >
                                                                        <InputNumberItem
                                                                            disabled
                                                                            dinero
                                                                            placeholder={`T. C. ${this.state.datosVenta?.moneda?.abreviacion ? this.state.datosVenta?.moneda?.abreviacion : ''}`}
                                                                        />
                                                                    </FormItem>
                                                                    <p style={{ textAlign: 'center' }}>Tipo de cambio venta: {dineroDisabledMask(this.state.datosVenta?.tipoDeCambio)}</p>
                                                                </>
                                                            )
                                                        }
                                                    }}
                                                </FormItem>
                                            </>
                                        )}
                                        formaDePagoContent={(
                                            <Row gutter={[6, 4]}>
                                                <Col span={24}>
                                                    <FormItem 
                                                     name="formaDePagoId"
                                                     label="F Pago" 
                                                     margin 
                                                     labelCol={{ span: 5 }}
                                                     wrapperCol={{ span: 18 }}>
                                                        <SelectItem disabled  noDisabledBackground>{this.state.objetoFormasDePago}</SelectItem>
                                                    </FormItem>
                                                </Col>
                                                <FormItem noStyle shouldUpdate={(prev, curr) => prev.factura !== curr.factura}>
                                                    {({ getFieldValue }) => {
                                                        const factura = getFieldValue("factura");
                                                        if (factura === 1) {
                                                            return (
                                                                <Col span={24}>
                                                                    <FormItem name="usoDeCfdiId" label="Uso CFDI" margin labelCol={{ span: 5 }} wrapperCol={{ span: 18 }}>
                                                                        <SelectItem disabled  noDisabledBackground>{this.state.objetoUsosDeCFDI}</SelectItem>
                                                                    </FormItem>
                                                                </Col>
                                                            );
                                                        }
                                                        return null;
                                                    }}
                                                </FormItem>
                                            </Row>
                                        )}
                                        tabs={[{ key: "insumos", label: "Insumos", listName: "insumos", columns: this.getInsumosColumns(), renderRow: this.renderInsumoRow.bind(this) }]}
                                        defaultActiveKey="insumos"
                                        isMobile={isMobile}
                                        formInstance={this.formRef.current}
                                        observacionesConfig={(() => {
                                            const config = this.getObservacionesConfig();
                                            return { ...config, totales: (
                                                <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
                                                    <tbody><tr><th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>Subtotal</th><td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>{dineroDisabledMask(this.state.subtotal)}</td></tr></tbody>
                                                    {this.state.arrayImpuestos.map((vA, idx) => <tbody key={idx}><tr><th className="th-totales" style={{ fontSize: "16px" }}>{vA.descripcionFactura}</th><td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(vA.totalImpuestos)}</td></tr></tbody>)}
                                                    <tbody><tr><th className="th-totales" style={{ fontSize: "16px" }}>Total</th><td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(this.state.total)}</td></tr></tbody>
                                                    {this.state.arrayRetenciones.map((v, idx) => <tbody key={idx}><tr><th className="th-totales" style={{ fontSize: "16px" }}>{v.descripcionFactura}</th><td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(v.totalRetenciones)}</td></tr></tbody>)}
                                                    <tbody><tr><th className="th-totales" style={{ fontSize: "17px" }}>Total a Pagar</th><td className="td-totales-right" style={{ fontSize: "17px" }}>{dineroDisabledMask(this.state.totalPagar)}</td></tr></tbody>
                                                </table>
                                            )};
                                        })()}
                                        actionButtons={(
                                            <>
                                                {this.state.totalPagado > 0 && <ButtonItem type="primary" icon={<DollarOutlined />} verdeB onClick={() => this.setState({ modalPagos: true })}>Pagos</ButtonItem>}
                                                <ButtonItem 
                                                    icon={<DownloadOutlined />} 
                                                    cyanB
                                                    onClick={() => this.descargarDevolucion(this.state.id)}>
                                                    Descargar
                                                </ButtonItem>
                                                <ButtonItem 
                                                    type="primary" 
                                                    icon={<SendOutlined />} 
                                                    azulMB 
                                                    onClick={() => this.enviarDevolucion(this.state.id)}>
                                                    Mandar Correo
                                                    </ButtonItem>
                                                <ButtonItem 
                                                    type="primary" 
                                                    rojoB
                                                    onClick={this.atras.bind(this)}>
                                                    Regresar
                                                </ButtonItem>
                                            </>
                                        )}
                                    />
                                )}
                            </FormItem>
                        </Form>
                    </Spin>
                </div>
                <MandarCorreoDevolucion visible={this.state.modalCorreo} id={this.state.modalCorreoId} cerrarMandarCorreoDevolucion={this.cerrarMandarCorreoDevolucion.bind(this)} history={this.props.history} />
                <PagosDevolucion visible={this.state.modalPagos} cerrarPagosDevolucion={this.cerrarPagosDevolucion.bind(this)} devolucionId={this.state.id} />
            </>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturarVentas:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
            )?.activado,
        certificada: state.empresa.certificada,
    };
};

export default connect(mapStateToProps)(VerDevolucion);